const filterBySearch = <T>(data: T[], keys: (keyof T)[], searchString: string): T[] => {
    const result = data.filter((element) =>
        keys.some(
            (key) =>
                typeof element[key] === 'string' && (element[key] as unknown as string).toLowerCase().includes(searchString.toLowerCase()),
        ),
    )
    return result
}

export default filterBySearch
